import { EmailEntity } from '@core/entities';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { inject } from '@angular/core';
import { EmailService, ImageConversionService } from '@core/services';

export class UseEmail {
  private readonly _emailService = inject(EmailService);
  private readonly _imageConversionService = inject(ImageConversionService);

  getAllEmailTemplates() {
    return this._emailService.find().pipe(
      map((res) => {
        if (res && res.length > 0) {
          return res.map((item: EmailEntity) => {
            const emailEntity = plainToClass(EmailEntity, item);
            if (emailEntity.templateLogo && emailEntity.templateLogo.length) emailEntity.imageUrl = this._imageConversionService.convertBase64ToSafeUrl(emailEntity.image);
            return emailEntity;
          });
        }
        return null;
      }),
    );
  }

  getEmailTemplateById(id: number) {
    return this._emailService.get(id).pipe(
      map((res: EmailEntity) => {
        if (res) {
          const emailEntity = plainToClass(EmailEntity, res);
          if (emailEntity.templateLogo && emailEntity.templateLogo.length) emailEntity.imageUrl = this._imageConversionService.convertBase64ToSafeUrl(emailEntity.image);
          return emailEntity;
        }
        return null;
      }),
    );
  }

  addEmailTemplate(formData: FormData) {
    return this._emailService.create(formData);
  }

  updateEmailTemplate(id: number, formData: FormData) {
    return this._emailService.update(id, formData);
  }

  deleteEmailTemplate(id: number) {
    return this._emailService.delete(id);
  }
}
